// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

// 0 is a valid loss value so we need to define null if loss is an empty string
const formatLosses = l => ({
  commonLoss: castToFloat(l.commonLoss),
  rxTotalLoss: castToFloat(l.rxTotalLoss),
  txTotalLoss: castToFloat(l.txTotalLoss),
})

export default formatLosses
